import * as React from "react"
import { sanitize } from "§/src/utils/functions"
import UniversalLink from "§/src/utils/UniversalLink"

/**
 * Internal dependencies.
 */
import "./_hero-content.scss"

const HeroContent = props => {
  const {
    badge,
    content,
    cta,
    pretitle,
    subTitle,
    title,
    titleTag,
    darkTheme,
    ...atomProps
  } = props.data

  // set atom class
  const atomClassName = "hero-content position-" + props?.data?.contentPosition
  var atomClass =
    props.className !== undefined
      ? atomClassName + " " + props.className
      : atomClassName

  // title tag
  // (div, h1, h2 - default h2)
  const TitleTag = titleTag || "h2"

  return (
    <div className={atomClass + " " + (darkTheme ? "dark" : "")}>
      <div className={"d-flex flex-column align-items-start"}>
        {pretitle && (
          <span
            className="child pretitle mb-1"
            dangerouslySetInnerHTML={{ __html: sanitize(pretitle) }}
          />
        )}
        {title && (
          <TitleTag className="child title h1">
            <span dangerouslySetInnerHTML={{ __html: sanitize(title) }} />
            {badge && (
              <span className="btn btn-sm btn-badge btn-warning ms-sm-3">{badge}</span>
            )}
          </TitleTag>
        )}
        {subTitle && (
          <h3
            className="child subtitle mb-3"
            dangerouslySetInnerHTML={{ __html: sanitize(subTitle) }}
          />
        )}
        {content && (
          <div
            className="child content"
            dangerouslySetInnerHTML={{ __html: sanitize(content) }}
          />
        )}
        {cta && cta[2] && (
          <UniversalLink
            className="child cta btn btn-lg btn-outline-light"
            to={cta}
          >
            {cta[2]}
          </UniversalLink>
        )}
      </div>
    </div>
  )
}

export default HeroContent
